<!-- @format -->

<sis-module-box [moduleGroupId]="selection.moduleGroupId" [attainment]="attainment">
  @if (canDelete) {
    <div module-box="extraitemholder">
      <div class="additional-box">
        <sis-button class="button-box" [link]="true" (clicked)="deleteCallback.emit()" [ariaLabel]="'ARIA_LABEL.DELETE' | translate">
          <sis-icon icon="delete"></sis-icon>
        </sis-button>
      </div>
    </div>
  }

  <div module-box="notifications">
    @if (selection.validityPeriod) {
      <div>
        @if (selection.validityPeriod.endDate && !(selection.validityPeriod | dateRangePast)) {
          <ng-container
            [ngTemplateOutlet]="notification"
            [ngTemplateOutletContext]="{
              icon: 'open',
              key: 'PROFILE.STUDY_RIGHT_SELECTIONS.VALID_PERIOD',
              params: { range: (selection.validityPeriod | localDateRange) },
            }">
          </ng-container>
        }
        @if (selection.validityPeriod | dateRangePast) {
          <ng-container
            [ngTemplateOutlet]="notification"
            [ngTemplateOutletContext]="{
              icon: 'close',
              key: 'PROFILE.STUDY_RIGHT_SELECTIONS.VALIDITY_ENDED',
              params: { endDate: (selection.validityPeriod.endDate | previousDay | localDateFormat) },
            }">
          </ng-container>
        }
        @if (!selection.validityPeriod.endDate) {
          <ng-container
            [ngTemplateOutlet]="notification"
            [ngTemplateOutletContext]="{
              icon: 'open',
              key: 'PROFILE.STUDY_RIGHT_SELECTIONS.VALID_FROM',
              params: { startDate: (selection.validityPeriod.startDate | localDateFormat) },
            }">
          </ng-container>
        }
      </div>
    }
  </div>
</sis-module-box>

<ng-template #notification let-key="key" let-params="params" let-icon="icon">
  <sis-tooltip [tooltipText]="key | translate: params">
    <div class="studymodule-notification-bar sis-tooltip-trigger-content">
      <span class="studymodule-notification">
        <span class="studymodule-notification-content" [translate]="key" [translateParams]="params"> </span>
        <span class="studymodule-notification-header">
          <sis-icon [icon]="icon === 'open' ? 'lock-open' : 'lock'"></sis-icon>
        </span>
      </span>
    </div>
  </sis-tooltip>
</ng-template>
